/**
 * Channel filter title component.
 */
import ButtonsContainer from '@components/atoms/container/channelFilterButtonsContainer';
import Title from '@components/atoms/text/channelFilterTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import FilterArrow from './filterArrow';

/**
 * Channel filter title component.
 * Renders the channel filter title with an arrow left icon if the list index is greater than 1.
 */
export default function ChannelFilterTitle() {
  return (
    <ButtonsContainer>
      <Title>{TranslationManager.get('COMPONENTS.FILTER.CHANNELS')}</Title>
      <FilterArrow />
    </ButtonsContainer>
  );
}
